import React from 'react';
import { StorePanel } from 'features/store';
import { SearchPanel } from 'features/search';
import { CategoriesPanel } from 'entities/Menu/components/CategoriesPanel';

interface IProps {
  isSearchMode: boolean;
}

export const MainPanel: React.FC<IProps> = React.memo(({ isSearchMode }) => {
  return (
    <>
      <StorePanel />
      <SearchPanel />
      {!isSearchMode && <CategoriesPanel />}
    </>
  );
});
